module.exports = __webpack_public_path__ + "img/77.069d4740.png";